module.exports = __webpack_public_path__ + "assets/img/00045.3fdc4df0.png";